import { create } from 'zustand'

interface DomainStoreType {
  domainInactive: boolean
  domainInactiveMsg: string
  setDomainInactive: (msg: string) => void
}

export const useDomainStore = create<DomainStoreType>(set => ({
  domainInactive: false,
  domainInactiveMsg: '',
  setDomainInactive: (msg: string) => {
    set({ domainInactive: true, domainInactiveMsg: msg })
  }
}))
